import { useState } from 'react';
import { Marker } from 'react-map-gl';
import FallbackImage from './FallbackImage';
import { places } from './travelData';

function Markers({ activePlaceId, focusPlace, openPhoto }) {
  const [hoveredMarker, setHoveredMarker] = useState(null);

  if (activePlaceId) {
    const activePlace = places.find((place) => place.id === activePlaceId);

    if (!activePlace) return null;

    return activePlace.photos.map((photo, index) => (
      <Marker
        anchor="bottom"
        key={photo.id}
        latitude={photo.latitude}
        longitude={photo.longitude}
        onClick={(event) => {
          event.originalEvent?.stopPropagation();
          openPhoto({ ...photo, placeId: activePlace.id, placeName: activePlace.name });
        }}
        style={{ zIndex: hoveredMarker === photo.id ? 8 : index + 1 }}
      >
        <button
          className="photo-marker"
          type="button"
          onClick={() => openPhoto({ ...photo, placeId: activePlace.id, placeName: activePlace.name })}
          onMouseEnter={() => setHoveredMarker(photo.id)}
          onMouseLeave={() => setHoveredMarker(null)}
        >
          <FallbackImage
            src={photo.thumbnail || photo.src}
            alt={photo.title}
            label={activePlace.name}
            aspect="square"
          />
        </button>
      </Marker>
    ));
  }

  return places.map((place, index) => (
    <Marker
      anchor="bottom"
      key={place.id}
      latitude={place.latitude}
      longitude={place.longitude}
      onClick={(event) => {
        event.originalEvent?.stopPropagation();
        focusPlace(place);
      }}
      style={{ zIndex: hoveredMarker === place.id ? 8 : index + 1 }}
    >
      <button
        className="place-marker"
        type="button"
        onClick={() => focusPlace(place)}
        onMouseEnter={() => setHoveredMarker(place.id)}
        onMouseLeave={() => setHoveredMarker(null)}
      >
        <span className="place-marker-label">{place.name}</span>
        <span className="place-marker-meta">{place.photos.length} images</span>
        <span className="marker-pointer" />
      </button>
    </Marker>
  ));
}

export default Markers;
